import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['overlay', 'panel', 'closeButton']

  connect () {
    this.previouslyFocused = null
    this.handleKeydown = this.onKeydown.bind(this)
    this.overlayEl = this.hasOverlayTarget ? this.overlayTarget : null
    this.panelEl = this.hasPanelTarget ? this.panelTarget : null
    this.closeButtonEl = this.hasCloseButtonTarget ? this.closeButtonTarget : null
    this.portalOverlay()
    this.bindDelegatedClicks()
  }

  disconnect () {
    this.unbindDelegatedClicks()
    this.close()
    this.restoreOverlay()
  }

  portalOverlay () {
    if (!this.overlayEl || this.overlayEl.parentElement === document.body) return

    this.overlayHome = this.overlayEl.parentElement
    this.overlayNextSibling = this.overlayEl.nextElementSibling
    document.body.appendChild(this.overlayEl)
  }

  restoreOverlay () {
    if (!this.overlayEl || !this.overlayHome || !document.body.contains(this.overlayEl)) return

    if (this.overlayNextSibling?.parentElement === this.overlayHome) {
      this.overlayHome.insertBefore(this.overlayEl, this.overlayNextSibling)
    } else {
      this.overlayHome.appendChild(this.overlayEl)
    }
  }

  bindDelegatedClicks () {
    if (!this.overlayEl) return

    this.onOverlayClick = (event) => {
      const action = event.target.closest('[data-rider-trust-action]')?.dataset.riderTrustAction
      if (action === 'close' || event.target === this.overlayEl) this.close(event)
    }
    this.overlayEl.addEventListener('click', this.onOverlayClick)
  }

  unbindDelegatedClicks () {
    if (this.overlayEl && this.onOverlayClick) {
      this.overlayEl.removeEventListener('click', this.onOverlayClick)
    }
  }

  open (event) {
    event?.preventDefault()
    if (!this.overlayEl) return

    this.previouslyFocused = event?.currentTarget || document.activeElement
    this.overlayEl.classList.remove('hidden')
    this.overlayEl.setAttribute('aria-hidden', 'false')
    document.body.classList.add('overflow-hidden')
    document.addEventListener('keydown', this.handleKeydown)
    requestAnimationFrame(() => this.closeButtonEl?.focus())
  }

  close (event) {
    event?.preventDefault()
    if (!this.overlayEl) return

    this.overlayEl.classList.add('hidden')
    this.overlayEl.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('overflow-hidden')
    document.removeEventListener('keydown', this.handleKeydown)
    this.previouslyFocused?.focus()
    this.previouslyFocused = null
  }

  onKeydown (event) {
    if (event.key === 'Escape') this.close(event)
  }
}
